<template>
  <b-container fluid class="d-flex justify-content-center align-items-center min-vh-100 bg-base">
    <b-row class="w-100">
      <b-col cols="12" md="6" lg="4" class="mx-auto">
        <b-card class="p-4 border-0 shadow-lg rounded-4 bg-white">
            <div class="text-center mb-4">
                <img src="../assets/logo.png" alt="logo" class="img-fluid mx-auto text-center" style="width: 100px; height: 100px;" />
            </div>
          <h3 class="text-base mb-1 text-center">Entre no Meu Ateliê</h3>
          <div class="text-center mb-2">
              <small class="small fs-6">Um produto <strong>Dayse Costa</strong></small>                
          </div>

          <b-form @submit.prevent="login">
            <b-form-group label="Email" label-for="email-input">
                <template #label>
                     <span class="font-weight-bold h6">Email</span>
                </template>
              <b-form-input
                id="email-input"
                v-model="form.email"
                type="email"
                placeholder="Seu email"
                required
                class="rounded px-2 py-3"
              ></b-form-input>
            </b-form-group>

            <b-form-group class="mb-2" label="Senha" label-for="password-input">
                <template #label>
                     <span class="font-weight-bold h6">Senha</span>
                </template>
              <b-input-group>
                <b-form-input
                  id="password-input"
                  :type="showPassword"
                  v-model="form.password"
                  placeholder="Sua senha"
                  autocomplete="on"
                  required
                  class="rounded-start px-2 py-3 border-end-0"
                ></b-form-input>
                <b-input-group-append>
                  <b-button 
                    variant="outline-secondary" 
                    @click="handleShowPassword"
                    class="border-start-0 px-3 password-toggle-btn"
                  >
                    <b-icon :icon="showPassword === 'password' ? 'eye-fill' : 'eye-slash-fill'"></b-icon>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <div class="mt-3">
                <b-button type="submit" block :disabled="loading" class="rounded-pill py-3 bg-base border-0 text-white">
                    <b-spinner small v-if="loading" class="mr-2" />
                    <span v-if="!loading">Login</span>
                    <span v-else>Entrando...</span>
                </b-button>
            </div>

            <div class="mt-3">
              <a href="/forgotpassword" class="text-secondary small">Esqueci minha senha</a>
            </div>

            <bAlert
                v-model="showAlert"
                :variant="alertType"
                dismissible
                class="mt-3 text-center"
                fade
                >
                {{ msg }}
            </bAlert>
            
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import store from "@/store"
import axios from "axios";
import { BIcon } from 'bootstrap-vue';

export default {
    components: {
        BIcon
    },
    data(){
        return {
            form:{
                email: null,
                password: null
            },
            msg: '',
            showPassword: "password",
            loading: false, 
            alertType: 'warning',
            showAlert: false,
        }
    },
    computed:{
        message() {
            return this.msg ? this.msg : '';
        }
    },
    methods:{
        login() {         
            this.loading = true;   
            axios.post(process.env.VUE_APP_ROOT_API + "/auth/signin", {
                    email: this.form.email,
                    password:this.form.password
            }, {
                headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                    }
                }).then(({data, status})=> {

                    if (status === 200) {
                        store.commit("setAuth", true)
                        localStorage.setItem("isAuth", true)
                        localStorage.setItem('token', data.token)
                        localStorage.setItem('user', JSON.stringify(data.user))
                    
                        // localStorage.setItem("user", JSON.stringify({username:"Lean Blanh"}))
                        this.$router.push({name:"Home", params:{auth:true} })
                    }

                }).catch((error) => {
                    if (error.response) {
                        if (error.response.status === 401 || error.response.status === 403) {
                          this.showMessage("Usuário ou Senha inválidos")
                        } else if (error.response.status === 500) {
                          this.showMessage("Erro no Servidor. Entre em contato com o Administrador.")
                        }
                        } else if (error.request) {
                          // Erro de rede ou servidor fora do ar
                          this.showMessage("Não foi possível conectar ao servidor. Verifique sua conexão ou tente mais tarde.", "danger");
                        } else {
                          // Outro erro inesperado
                          this.showMessage("Erro inesperado: " + error.message, "danger", 10);
                        }
            }).finally(() => {
                this.loading = false;
            });
        },
        handleShowPassword() {
            if (this.showPassword=="password") {
                this.showPassword = "text";
            } else {
                this.showPassword = 'password'
            }
        
        },
        showMessage(text, type = 'warning', duration = 5) {
            this.msg = text;
            this.alertType = type;
            this.showAlert = duration;
        }
    }
}
</script>

<style lang="scss">
@import "../custom/custom.scss";


.password-toggle-btn {
  border-color: $border-color;
  background-color: transparent;
  height: 100%;
  border-left: 0;
  margin-left: 0;
  padding-top: calc(0.375rem - 1px);    // Perfect alignment with -1px
  padding-bottom: calc(0.375rem - 1px);  // Perfect alignment with -1px
  
  &:hover, &:active, &:focus {
    border-color: $border-color !important;
    background-color: transparent !important;
    box-shadow: none !important;
    opacity: 1;
    color: $primary !important;
  }

  .b-icon {
    opacity: 0.7;
    transition: opacity 0.2s ease;
  }

  &:hover .b-icon {
    opacity: 1;
  }
}

.input-group {
  .form-control {
    border-right: 0; // Remove right border
    
    &:focus {
      border-right: 0;
      
      & + .input-group-append .btn {
        border-color: $border-color;
      }
    }
  }
  
  .input-group-append {
    margin-left: 0; // Remove default margin
  }
}

.bg-base {
  background-color: $primary;
}

.text-base {
  color: $primary;
}
</style>